const fallbackUrl = () => `https://www.vistaprint.com/assets/new-relic-microagent`;
const productionUrl = (domain) => `https://www.${domain}/assets/new-relic-microagent`;
const url = (hostname) => {
  const result = hostname.match(/vistaprint\.[a-z]{2,3}(\.[a-z]{2,3})?/);
  if (result && result[0]) {
    return productionUrl(result[0]);
  }
  return fallbackUrl();
};

export { url };
